import React, {Component, useState} from "react";
import {logoutUser, useAuthDispatch, useAuthState} from "../../Context";


function Logout(props){
    const dispatch = useAuthDispatch();
    const handleLogout = async (e) => {
        e.preventDefault();

        try {
            let response = await logoutUser(dispatch);
            console.log(response)
            if (response.status === 200){
                props.history.push('/');
            };

        } catch (error) {
            console.log(error);
        }
    };
    return (
        <div className="submit-form">

            <button onClick={handleLogout} className="btn btn-success">
                Log Out
            </button>
        </div>
    )
}


export default Logout
